import { CanMatchFn, Route, UrlSegment } from '@angular/router';
import { EntityProfileType, EntityProfileTypes } from '@rma/public/generic/domain/types';

export const entityProfileTypeGuard: CanMatchFn = (_route: Route, segments: UrlSegment[]) => {
  const type = segments[0]?.path;
  // SAFETY(legacy): unreviewed, pre-dates this rule.
  return Object.values(EntityProfileTypes).includes(type as EntityProfileType);
};
